export type Zone = (typeof ZONES)[number]

export const DEFAULT_ZONE = 'paris' as const
export const ZONES = ['paris', 'lyon'] as const

export const ZONE_SEARCH_PATHS = ZONES.map((zone) => `/${zone}`)
